import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import store from './store'
import consts from './consts'
import utils from './utils'
import colorUtils from './colorUtils'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$consts = consts
Vue.prototype.$utils = utils
Vue.prototype.$colorUtils = colorUtils

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
